import React from "react";
import { FaPalette, FaCube, FaLayerGroup } from "react-icons/fa";

function UniqueDigitalArts() {
  return (
    <>
      <div
        className="feature-style-one-area default-padding bg-gray blurry-shape-right-bottom"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/3.png)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Features</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  NFT Development Service by Xeer Technology
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="fade-up-anim">
            <div className="row">
              <div className="col-xl-3 pr-50 pr-md-15 pr-xs-15">
                <div className="feature-style-one-left-info">
                  <div className="">
                    <p>
                      At Xeer Technology, we specialize in offering
                      comprehensive NFT development services, tailored to meet
                      the unique needs of creators, businesses, and developers
                      looking to enter the fast-growing world of non-fungible
                      tokens. From conceptualization to deployment, we help you
                      build and launch NFTs that stand out in the marketplace.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-xl-9">
                <div className="feature-style-three-items fade-up-anim">
                  <div className="feature-style-one hover-active-item ">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaPalette size={35} />
                      </div>
                      <h4>Designing Unique Digital Arts</h4>
                      <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Maxime, ratione.
                      </p>
                    </div>
                  </div>

                  <div className="feature-style-one hover-active-item">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaCube size={35} />
                      </div>
                      <h4>Minting Tokens on Blockchain</h4>
                      <p>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Id, quia.
                      </p>
                    </div>
                  </div>

                  <div className="feature-style-one hover-active-item">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaLayerGroup size={35} />
                      </div>
                      <h4>Managing NFT Collections</h4>
                      <p>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Id, quia.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UniqueDigitalArts;
